var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenuWorkshop = function SvgMenuWorkshop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "workshop_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "workshop_24dp"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.908313, 4.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "16 12 14 12 14 11 6 11 6 12 4 12 4 11 0 11 0 16 20 16 20 11 16 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4 L15,4 L15,2 C15,0.9 14.1,0 13,0 L7,0 C5.9,0 5,0.9 5,2 L5,4 L2,4 C0.9,4 0,4.9 0,6 L0,10 L4,10 L4,8 L6,8 L6,10 L14,10 L14,8 L16,8 L16,10 L20,10 L20,6 C20,4.9 19.1,4 18,4 Z M13,4 L7,4 L7,2 L13,2 L13,4 Z",
    id: "\\u5F62\\u72B6"
  }))))));
};

export { SvgMenuWorkshop as ReactComponent };
export default __webpack_public_path__ + "2f9a248d5c4355bc55d2b55feca38340.svg";